import StarBarAndRating from '@components/Reviews/DefaultRenderedComponents/StarsRatingBar';
import VerticalDivider from '@components/VerticalDivider';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import _ from 'lodash';
import { FC } from 'react';
import { ReviewData } from '@common/types';
import s from '../ProjectsReviews.module.scss';

type ReviewHeaderProps = {
  review: ReviewData;
};

const dateWidth = 87;
const ReviewHeader: FC<ReviewHeaderProps> = ({ review }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const clientShortName = review.clientName;
  const overallScore = review.overallScore || review.score?.average || 0;
  return (
    <Box
      direction="horizontal"
      dataHook="review-header"
      gap="SP2"
      marginBottom="SP3"
      width="100%"
      verticalAlign="middle"
      className={s.reviewHeader}
    >
      <Box align="space-between" minWidth="max-content">
        {!_.isNil(overallScore) && (
          <StarBarAndRating
            overallScore={overallScore}
            className={s.ratingBar}
            size="tiny"
            numericalRatings={{
              size: 'medium',
              weight: 'normal',
            }}
          />
        )}
      </Box>
      <VerticalDivider />

      <Box marginBottom="4px" minWidth="0" gap="SP2" verticalAlign="middle">
        {review.clientName && (
          <>
            <Text
              size="small"
              weight="normal"
              secondary
              dataHook="review-client-name"
              ellipsis
            >
              {clientShortName}
            </Text>
            <VerticalDivider />
          </>
        )}
        {review.date && (
          <Box width="fit-content" minWidth={dateWidth}>
            <Text size="small" weight="normal" secondary dataHook="review-date">
              {review.date &&
                Intl.DateTimeFormat(language, {
                  year: 'numeric',
                  month: 'short',
                  day: 'numeric',
                }).format(new Date(review.date))}
            </Text>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ReviewHeader;
